import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { UserService } from '../../services/user.service';
import { MatDialog } from '@angular/material/dialog';
import { IaqChartsComponent } from '../iaq-charts/iaq-charts.component';

@Component({
  selector: 'app-firmware.component',
  templateUrl: './firmware.component.component.html',
  styleUrls: ['./firmware.component.component.css']
})
export class FirmwareComponentComponent implements OnInit {
  locationData: any;
  weatherResponse: any;
  weatherWorking = false;
  locationId: any;
  memberInfoToggle:boolean = true;
  eventInfoToggle:boolean = true;

  constructor(private http: HttpClient, private router: Router, private route: ActivatedRoute, private userService: UserService, private dialog: MatDialog) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.locationId = params.get('id') || '';
      this.fetchLocationData();
    });
  }

  fetchLocationData(): void {
    if (!this.locationId) {
      console.error('No location ID provided.');
      return;
    }
    this.userService.getLocationData(this.locationId).subscribe(
      (data) => {
        this.locationData = data;
      },
      (error) => {
        console.error('Error fetching location data:', error);
      }
    );
  }

  capitalizeFirstLetter(str: string | null | undefined): string {
    if (!str) {
      return '';
    }
    const capitalizedStr = str.charAt(0).toUpperCase() + str.slice(1);
    return capitalizedStr.replace(/_/g, ' ');
  }

  openIAQChartsPopup() {
    this.dialog.open(IaqChartsComponent, {
      width: '90%',
      height: '90%',
      data: {
        locationID: this.locationData.id,
        userID: this.locationData.user_id,
        locationLabel: this.locationData.label
      }
    })
  }
}
